

/*function report( getReportValueFn, reportFn){
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                let reportVal = getReportValueFn.call(this)
                reportFn(reportVal)

                return targetFunction.call(this, ...arg)
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}*/


/**
 * 装饰器-负责上报
 *
 * @reportListOrgetReportValueFn 上报参数，接受的参数格式有如下几种：
 * {
 *      value: '' || function(){},
 *      action: reportFunction
 * }
 *
 * {
 *      key: '',
 *      value: '' || function(){},
 *      action: reportFunction
 * }
 *
 * {
 *      targetSelector: '#id.class',
 *      eventName: 'click',
 *      params: function(){},
 *      action: reportFunction(e, params)
 * }
 *
 */
export function report( reportListOrgetReportValueFn, reportFn){
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                /*let reportVal = getReportValueFn.call(this)
                reportFn(reportVal)
                return targetFunction.call(this, ...arg)*/
                if(Array.isArray(reportListOrgetReportValueFn)){
                    let reportList = reportListOrgetReportValueFn
                    reportList.forEach(report=>{
                        let args = []
                        const {key, value, targetSelector, eventName, action, params, condition } = report
                        let reportCondition = true
                        if(typeof condition === 'function'){
                            reportCondition = condition.call(this)
                        }
                        if(!!reportCondition){
                            if(key || value){
                                value && args.push('function'===typeof value ? value.call(this) : value)
                                key && args.push(key)
                                // console.log('上报参数====>', args, key, value)
                                action.apply(this, args)
                            }else if(!key && !value && !(targetSelector && eventName)){
                                action.apply(this)
                            }else if(targetSelector && eventName){
                                // 考虑未来可能写多个 jumpUrl，所以这里需改为querySelectorAll，否则仅第一个可绑定点击事件成功
                                const targetEl = document.querySelectorAll(targetSelector)
                                console.log('上报参数-click ====>', targetEl, targetSelector, eventName)
                                targetEl && targetEl.forEach((item)=>{
                                    item.addEventListener("click",(e)=> {
                                        console.log('do ------- 点击上报',e)
                                        action.call(this, e, params);
                                    }, false)
                                })
                            }
                        }
                    })
                }
                return targetFunction.call(this, ...arg)
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}


/**
 * 用于兼容有问题sdk
 * @param checkFn 检查需要被兼容处理的sdk版本方法 返回true为需要兼容，false不需要兼容
 * @param compatibleObject 兼容处理对象
 * @returns {Function}
 */
export function compatible(checkFn, compatibleObject){
    let decoratorObj = null
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                //如果sdkVersion为要兼容的版本 调用兼容方法compatibleFn
                if(checkFn()){
                    !decoratorObj && (decoratorObj = new compatibleObject())
                    return decoratorObj[targetFunction.name].call(this, ...arg)
                }else{
                    //如果sdkVersion为不需要兼容的版本 调用原本的方法
                    return targetFunction.call(this, ...arg)
                }
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}

/**
 * 装饰器 ，如果有入参方法，则入参方法只执行一次，否则被装饰方法只执行一次
 * @param onceFn {Function} 若传入该onceFn方法，则onceFn只执行一次，否则被装饰方法只执行一次
 */
export function once(onceFn){
    let called = false
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if('function' === typeof targetFunction){
            descriptor.value = function(...arg){
                if(!called){
                    called = true
                    if(onceFn){
                        onceFn.call(this, ...arg)
                    }
                    targetFunction.call(this, ...arg)
                }else {
                    if(onceFn){
                        targetFunction.call(this, ...arg)
                    }
                }
            }
        } else {
            console.warn('once装饰器只能装饰在类的实例方法上')
        }
    }
}